
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_30284","data-name":"Group 30284","xmlns":"http://www.w3.org/2000/svg","width":"4","height":"10.063"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30135","data-name":"Group 30135"}},[_c('g',{attrs:{"id":"Group_30140","data-name":"Group 30140","fill":"#97a0ae"}},[_c('path',{attrs:{"id":"Path_20999","data-name":"Path 20999","d":"M3 3H1V1h2zm.068-3H.931A.931.931 0 000 .932V4h4V.932A.932.932 0 003.068 0"}}),_c('path',{attrs:{"id":"Path_21000","data-name":"Path 21000","d":"M3 9.063H1v-2h2zm1-3H0v3.068a.932.932 0 00.932.932h2.136A.932.932 0 004 9.131z"}}),_c('path',{attrs:{"id":"Path_21001","data-name":"Path 21001","d":"M3 6.063H1v-2h2zm1-3H0v4h4z"}})])])])
          )
        }
      }
    